export const commonQueryParams = (url, searchText, data) => {
    const { sortModel, page, pageSize, filterModel } = data;

    if (!url?.includes('?')) url += '?1=1';

    if (searchText) {
        url += `&SearchText=${searchText}`;
    }
    
    if (sortModel && sortModel[0]?.field) {
      //if (url && !searchText) {
      //  url += `SortDirection=${sortModel[0]?.sort}&SortColumnName=${sortModel[0]?.field}`;
      //} else {
        url += `&SortDirection=${sortModel[0]?.sort}&SortColumnName=${sortModel[0]?.field}`;
      //}
    }

    if (filterModel?.items?.length > 0) {
      url += '&filter=';
      for (const item of filterModel.items) {
        url += `${item.columnField}:${item.operatorValue}:${item.value}|`
      }
      url += `&filterLink=${filterModel.linkOperator}`;
    }
    
    //if (!sortModel[0]?.field && !searchText) {
    //  url += `PageNumber=${page}`;
    //} else {
    if (page)
      url += `&PageNumber=${page}`;
    //}
    if (pageSize)
      url += `&PageSize=${pageSize}`;
    
    return url;
}